import React from "react";
import { useStateValue } from "./StateProvider";
import "./SummaryDetail.css";

function SummaryDetail({ id = 1 }, { FrontBack } = "front") {
  const [{ scores }, ] = useStateValue();

  const getPlayerScoresF9 = (id) => {
    const playerscores = scores.filter((s) => s.id === id && s.hole <= 9);
    playerscores.sort((a, b) => {
      return a.hole - b.hole;
    });
    return playerscores;
  };
  const getPlayerScoresB9 = (id) => {
    const playerscores = scores.filter((s) => s.id === id && s.hole >= 10);
    playerscores.sort((a, b) => {
      return a.hole - b.hole;
    });
    return playerscores;
  };

  const getTotal = (selScores, frontback) => {
    const Total = selScores?.reduce(
      (totalStrokes, score) => totalStrokes + score.strokes,
      0
    );
    return Total;
  };

  const getGrandTotal = (id) => {
    const playerscores = scores.filter((s) => s.id === id);
    const Total = playerscores?.reduce(
      (totalStrokes, score) => totalStrokes + score.strokes,
      0
    );
    return Total;
  };


  return (
    <div>
      <div className="scores-totals">
        <div className="scores">
          {scores.filter((s) => s.hole <= 9).length > 0 ? (
            <div className="scoregrid">
              {getPlayerScoresF9(id).map((score, i) => (
                <div key={i} className="holescores">
                  <div className="holelabel">{score.hole}</div>
                  <div className="holestrokes">{score.strokes}</div>
                </div>
              ))}
              <div className="summary__totals">
                <div className="frontlabel">Front</div>
                <div className="f9Total">
                  {getTotal(getPlayerScoresF9(id), "front")}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {scores.filter((s) => s.hole >= 10).length > 0 ? (
            <div className="scoregrid">
              {getPlayerScoresB9(id).map((score, i) => (
                <div key={i} className="holescores">
                  <div className="holelabel">{score.hole}</div>
                  <div className="holestrokes">{score.strokes}</div>
                </div>
              ))}
              <div className="summary__totals">
                <div className="backlabel">Back</div>
                <div className="b9Total">
                  {getTotal(getPlayerScoresB9(id), "back")}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="totalfb">
          {scores.filter((s) => s.hole === 18).length > 0 ? (
            <div className="scoregrid">
              <div className="totals__vertical">
                <div className="totallabel">Total</div>
                <div className="summary__totals">
                  <div className="grandTotal">{getGrandTotal(id)}</div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

export default SummaryDetail;
